import { render, staticRenderFns } from "./m-menu-chip.vue?vue&type=template&id=d825f150&scoped=true&"
import script from "./m-menu-chip.vue?vue&type=script&lang=js&"
export * from "./m-menu-chip.vue?vue&type=script&lang=js&"
import style0 from "./m-menu-chip.vue?vue&type=style&index=0&id=d825f150&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d825f150",
  null
  
)

export default component.exports